import { environment } from 'src/environments/environment';

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]']);

/**
 * Local-only wallet mimic (e.g. MCP browser, demos without an admin wallet).
 * Enabled on loopback hostnames; set enableLocalMimic: false in an environment file to opt out.
 */
export function isLocalDevMimicEnabled(hostname?: string): boolean {
  if (environment.enableLocalMimic === false) {
    return false;
  }
  let host = hostname;
  if (!host && typeof window !== 'undefined') {
    host = window.location.hostname;
  }
  return LOCAL_HOSTNAMES.has((host ?? '').toLowerCase());
}
